export const getScenarioInfo = (entity) => {
    if (entity.activeRevision) {
        return {
            name: entity.activeRevision.name || '',
            description: entity.activeRevision.description || '',
        };
    }
    if (entity.inactiveRevisions && entity.inactiveRevisions.length > 0) {
        const latestRevision = entity.inactiveRevisions.reduce((latest, current) => {
            return current.version > latest.version ? current : latest;
        });
        return {
            name: latestRevision.name || '',
            description: latestRevision.description || '',
        };
    }
    if (entity.drafts && entity.drafts.length > 0 && entity.drafts[0].name) {
        return {
            name: entity.drafts[0].name || '',
            description: entity.drafts[0].description || '',
        };
    }
    return { name: '', description: '' };
};
